import api from '@/api'
import handleError from '@/lib/handleError.js'
import types from './types'
import _ from 'lodash'

export default {
  async postComment(context, payload) {
    const response = await api.comment
      .postComment(
        payload.organizationId,
        payload.modelName,
        payload.modelId,
        payload.comment
      )
      .catch(handleError)

    return response?.data
  },

  removeComment(context, payload) {
    return api.comment.removeComment(payload.organizationId, payload.commentId)
  },

  getCommentsByModelId(context, payload) {
    return api.comment
      .getCommentsByModelId(
        payload.organizationId,
        payload.modelName,
        payload.modelId
      )
      .then(({ data: comments }) => {
        context.commit(types['SET_COMMENTS'], comments)
      })
  },

  async getCommentById(context, payload) {
    const comment = await api.comment.findCommentById(
      payload.organizationId,
      payload.commentId
    )
    return comment
  },

  async translateComment(
    context,
    { organizationId, commentId, targetLanguage, fieldsToTranslate }
  ) {
    const { data: comment } = await api.comment.findCommentById(
      organizationId,
      commentId
    )

    const translatedComment = Object.assign({}, comment)

    for (const field of fieldsToTranslate) {
      if (!_.get(comment, field)) continue
      const translatedField = await api.translate.text(
        organizationId,
        _.get(comment, field),
        targetLanguage
      )
      _.set(translatedComment, field, translatedField.data.translatedText)
    }

    return translatedComment
  },
}
